import { CSSObject } from '@emotion/styled'
import { Box, Color, withCitrusTheme } from '@gousto-internal/citrus-react'

import bgImageLargePng from './assets/background-large.png'
import bgImageSmallPng from './assets/background-small.png'

export const ValueForMoneyContainer = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(
    [
      `65% bottom/639px no-repeat url(${bgImageSmallPng})`,
      `bottom/contain no-repeat url(${bgImageSmallPng})`,
      `30% 20%/cover no-repeat url(${bgImageLargePng})`,
    ],
    ['background'],
  ) as CSSObject),
}))

export const ConveniencesContainer = withCitrusTheme(Box, (theme) => ({
  borderRadius: '1rem',
  ...(theme.responsiveStyle(
    [theme.color(Color.Transparent), '#ecedefb3'],
    ['backgroundColor'],
  ) as CSSObject),
}))
